import { useEffect, useRef } from 'react';
import { useMediaQuery, useTheme } from '@mui/material';
import { useSidebarLayout } from '../../app-shell/context/SidebarProvider';

/**
 * Collapses app sidebar when context drawer opens (md+), restores on close.
 */
export default function useInterveneWorkspaceLayout(isDrawerOpen) {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const { collapsed, setCollapsedState } = useSidebarLayout();
  const sidebarBeforeRef = useRef(null);
  const collapsedRef = useRef(collapsed);

  useEffect(() => {
    collapsedRef.current = collapsed;
  }, [collapsed]);

  useEffect(() => {
    if (!isDrawerOpen || !isDesktop) {
      return undefined;
    }

    if (sidebarBeforeRef.current === null) {
      sidebarBeforeRef.current = collapsedRef.current;
    }
    setCollapsedState(true);

    return () => {
      if (sidebarBeforeRef.current !== null) {
        setCollapsedState(sidebarBeforeRef.current);
        sidebarBeforeRef.current = null;
      }
    };
  }, [isDrawerOpen, isDesktop, setCollapsedState]);
}
